import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const showComingSoonAlert = () => {
    MySwal.fire({
        title: 'Coming Soon',
        icon: 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
    });
};


export default showComingSoonAlert;
